import { BaseResource } from 'utils/ApiUtils';

export default class WitnessInspection extends BaseResource {
  static columns = [
    {
      title: "Inspection #",
      field: "InspectionNumber_Inspection"
    },
    { title: "Inspector", field: "Name_SystemUser" },
    {
      title: "Test Method",
      field: "Description_InspectionType"
    },
    {
      title: "Occurrence Date",
      field: "occurenceDate",
      type: "date",
      defaultSort: "desc"
    },
    {
      title: "Observed By",
      field: "observedBy"
    },
    {
      title: "Technician Observed",
      field: "technicianObserved"
    },
    {
      title: "Comments",
      field: "Description"
    }
  ];

  static attributes = WitnessInspection.columns.map((r) => r.field);

  static expand = [
    {
      InspectionType: {
        select: ["Description"]
      }
    },
    {
      "Ihwi": {
        expand: [
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          }
        ]
      }
    }
  ];

  constructor(args) {
    super(args, WitnessInspection.attributes);
  }
}
